import React from 'react'

const AccountNameViewUI = ({context, accountName}) =>
  <div>
    {accountName}
  </div>

export default AccountNameViewUI
